import React from 'react';
import { IWizardItem } from '../WizardItem';
import styles from './WizardButton.module.scss';
import useWizardButton from '../../../Hooks/useWizardButton';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';

interface Props {
	item: IWizardItem;
}

const WizardButton: React.FC<Props> = ({ item }) => {
	const { handleClick } = useWizardButton(item);
	const title = item.title || item.settings?.title;

	switch (item.subtype) {
		case WizardItemSubType.TEXT:
			return (
				<div className={styles.linkButton} onClick={handleClick}>
					{title}
				</div>
			);
		default:
			return (
				<div className={styles.wizardButton} onClick={handleClick}>
					{item.settings?.icon && (
						<img
							src={item.settings?.icon}
							alt='icon'
							className='size-45 button-list__btn__icon'
						/>
					)}
					<div className='button-list__btn__content'>
						<div className='button-list__btn__content__title'>{title}</div>
					</div>
					<div className='button-list__btn__arrow'>
						<img
							src='/dist/patientV3/icons/arrow-right-purple-small.svg'
							alt=''
						/>
					</div>
				</div>
			);
	}
};

export default WizardButton;
